import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// REMEMBER TO REMOVE THIS LINE IN PRODUCTION
// Initialize the database with test data
import { DataBase } from './testing/ServerTest';
DataBase(); // Ensure the database is set up before rendering the app
// REMEMBER TO REMOVE THIS LINE IN PRODUCTION

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
